import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';

import { AuthHttpService } from '../../services/auth-http.service';
import { AuthService } from '../../services/auth.service';
import { Credentials } from '../../interfaces/credentials';
import { GeolocationService } from '../../../../services/geolocation.service';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { SessionInfo } from '../../interfaces/session-info';
import { WINDOW } from '@shared/services/window.service';

import { environment } from 'environments/environment';

// Icons
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'shared-sign-in-student-form',
  templateUrl: './sign-in-student-form.component.html',
  styleUrls: ['./sign-in-student-form.component.scss'],
  standalone: false
})
export class SignInStudentFormComponent {

  environment = environment;

  credentials: Credentials = {
    AccountName: null,
    AuthProvider: 'CWK',
    Country: null,
    Email: '',
    FirstName: null,
    IsActive: false,
    LastName: null,
    Password: '',
    Timezone: null,
    Token: null
  };
  status = '';

  // Icons
  faSpinner = faSpinner;

  // Subscriptions
  private geolocationSubscription: Subscription;

  constructor(
    private authHttpService: AuthHttpService,
    private authService: AuthService,
    private geolocationService: GeolocationService,
    private localStorageService: LocalStorageService,
    private router: Router,
    @Inject(WINDOW) private window: Window | null
  ) {

    // Get current geolocation info
    this.geolocationSubscription = this.geolocationService.getObservable()
      .subscribe((value) => {
        this.credentials.Country = value.country_code;
        if (this.credentials.Country === 'US') {
          this.credentials.State = value.region_code;
        }
      });
  }

  cancel() {

    // Sign out
    this.authService.signOut().subscribe(() => {});

    // If the mode is set, go back to homepage
    //this.window.location.replace('/');
    history.back();
  }

  submit() {

    // Set status to wait
    this.status = 'WAIT';

    // If timezone is resolvable, pass it with credentials
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timezone) {
      this.credentials.Timezone = timezone;
    }

    // Send credentials to backend
    return this.authHttpService.signInStudent(this.credentials)
      .subscribe(
        (response: string) => {
          this.authService.signInSuccess(JSON.parse(response) as SessionInfo);
          this.router.navigate(['/' + environment.urlStudentProfilePath], { replaceUrl: true })
            .then(() => {
              if (this.window) {
                this.window.location.reload();
              }
            });
        },
        error => this.status = error.error
      );
  }
}
